import { useMqtt, type ConnSettings } from "./mqtt";

export function ConnectionBar() {
  const { connState, error, connect, disconnect, settings, setSettings } = useMqtt();
  const connected = connState === "connected";
  const busy = connState === "connecting";
  const locked = connected || busy;

  const stateText = connected ? "已连接" : busy ? "连接中…" : "未连接";
  const set = (patch: Partial<ConnSettings>) => setSettings(s => ({ ...s, ...patch }));

  return (
    <div className="conn-bar">
      <span className={`conn-dot ${connState}`} title={stateText} />
      <span className="conn-state">{stateText}</span>
      <input
        className="input mono grow"
        value={settings.host}
        placeholder="地址 192.168.x.x"
        disabled={locked}
        onChange={e => set({ host: e.target.value })}
      />
      <span className="conn-lbl">WS</span>
      <input
        className="input port mono"
        value={settings.wsPort}
        placeholder="9001"
        title="MQTT over WebSocket 端口"
        disabled={locked}
        onChange={e => set({ wsPort: e.target.value })}
      />
      <span className="conn-lbl">WHEP</span>
      <input
        className="input port mono"
        value={settings.whepPort}
        placeholder="8889"
        title="WebRTC(WHEP) 端口"
        disabled={locked}
        onChange={e => set({ whepPort: e.target.value })}
      />
      <input
        className="input"
        value={settings.username}
        placeholder="用户名（可空）"
        disabled={locked}
        onChange={e => set({ username: e.target.value })}
      />
      <input
        className="input"
        type="password"
        value={settings.password}
        placeholder="密码（可空）"
        disabled={locked}
        onChange={e => set({ password: e.target.value })}
      />
      <button
        className={`btn ${connected ? "btn-outline" : "btn-primary"}`}
        disabled={busy}
        onClick={() => (connected ? disconnect() : connect())}
      >
        {connected ? "断开" : "连接"}
      </button>
      {error && <span className="conn-error" title={error}>{error}</span>}
    </div>
  );
}
